
import { ActionCreate } from './ActionCreate';
import { ActionList } from './ActionsList';

export default {
    list: ActionList,
    create: ActionCreate
};
